// extracted by mini-css-extract-plugin
export default {"container":"PDFCard_container__S7mps"};